var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "11px",
    viewBox: "0 0 21 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E-learning-en-speelplaats",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "E-learning-zoeken-1ste-opengeklapt",
    transform: "translate(-357.000000, -352.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.482011,358.588199 C367.689134,359.377205 366.408451,359.377205 365.615573,358.588199 L365.615573,358.589748 L359.463805,352.437205 C358.914056,351.868098 358.006583,351.852612 357.437476,352.402361 C356.86837,352.95211 356.85211,353.859583 357.402633,354.42869 C357.413473,354.440304 357.425862,354.452693 357.437476,354.463533 L364.009687,361.037292 C365.69068,362.709768 368.407679,362.709768 370.088672,361.037292 L376.660108,354.465082 C377.229989,353.915333 377.245475,353.008634 376.695726,352.438753 C376.145977,351.869647 375.238504,351.854161 374.669397,352.40391 C374.657783,352.415524 374.645394,352.427139 374.63378,352.438753 L368.482011,358.588199 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDown);
export default __webpack_public_path__ + "static/media/expand-down.26bb8a99.svg";
export { ForwardRef as ReactComponent };